module.exports = __webpack_public_path__ + "img/Application-Scenarios-1.af026c6.jpg";